import React from "react";
import { Button } from "react-bootstrap";

interface TableHeaderControlsProps {
  totalCount: number;
  currentPageSize: number;
  onPageSizeChange: (pageSize: number) => void;
}

/**
 * Table header controls for page size management
 */
const TableHeaderControls = ({
  totalCount,
  currentPageSize,
  onPageSizeChange,
}: TableHeaderControlsProps) => {
  // Predefined quick options
  const quickOptions = [25, 50, 75, 100];

  return (
    <div className="d-flex justify-content-between align-items-center mb-3 p-2 bg-light rounded">
      {/* Left side: Total count info */}
      <div className="text-muted small">
        <strong>{totalCount}</strong> Einträge gesamt
      </div>

      {/* Right side: Page size controls */}
      <div className="d-flex align-items-center gap-2">
        <span className="text-muted me-2" style={{ fontSize: "0.9rem" }}>
          Zeige pro Seite:
        </span>

        {/* Quick option buttons */}
        <div className="btn-group btn-group-sm" role="group">
          {quickOptions.map((option) => (
            <Button
              key={option}
              variant={currentPageSize === option ? "primary" : "outline-dark"}
              size="sm"
              onClick={() => {
                onPageSizeChange(option);
              }}
            >
              {option}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TableHeaderControls;
